module.exports = __webpack_public_path__ + "img/Tour Button.8222df92.svg";